import React, { Fragment } from 'react';
import { Container, Hidden, Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Head from 'next/head';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import Header from '../../components/Header';
import Image from '../../components/Image';
import ToolsCard from '../../components/ToolsCard';
import Footer from '../../components/Footer';
import { isDesktop } from '../../helpers/general';
import Notification from '../../components/Notification';
import { seoFor } from '../../static/text/seo';
import useStyles from './tools-styles';
import { useAspectRatio } from '../../theme/common';
import AdSet from '../../components/AdSet';
import { withTranslation } from '../../i18n';
import Title from '../../components/Title';

const bmiImg = require('../../static/images/mfs/bmi_with_color.png');
const tdeeImg = require('../../static/images/mfs/tdee_with_color.png');
const bodyFatImg = require('../../static/images/mfs/stretch_with_color.png');
const intervalImg = require('../../static/images/mfs/gradient_tools.png');

function Tools(props) {
  const { i18n, t } = props;
  const classes = useStyles();
  const aspectRatio = useAspectRatio();
  const currentLanguage = i18n.language;
  const theme = useTheme();

  function renderGridAd() {
    if (isDesktop(theme)) {
      return (
        <Grid item md={3}>
          <AdSet className={classes.adStyle} fixedStyle={classes.fixedStyle} />
        </Grid>
      );
    }
    return null;
  }

  return (
    <Fragment>
      <Head>
        <title>{seoFor(currentLanguage).tools}</title>
        <meta name="description" content={seoFor(currentLanguage).desc.tools} />
        <meta property="og:title" content={seoFor(currentLanguage).tools} />
        <meta property="og:description" content={seoFor(currentLanguage).desc.tools} />
        <meta property="og:image" content="https://myfitsociety.com/static/images/mfs/og-fb-001.jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://myfitsociety.com/static/images/mfs/og-fb-001.jpeg" />
      </Head>
      <CssBaseline />
      <div className={classes.mainWrap}>
        <Header
          invert
        />
        <main className={classes.containerWrap}>
          <section id="tools">
            {/* <Hidden mdUp>
              <div className={clsx(classes.bannerContainer, aspectRatio.bannerArticle, classes.noRadius)}>
                <Image src="https://via.placeholder.com/1920" mobileSrc="https://via.placeholder.com/480" className={classes.imageStyle} />
              </div>
            </Hidden> */}
            <Container fixed className={classes.root}>
              {/* <Hidden smDown>
                <div className={clsx(classes.bannerContainer, aspectRatio.bannerArticle)}>
                  <Image src="https://via.placeholder.com/1920" mobileSrc="https://via.placeholder.com/480" className={classes.imageStyle} />
                </div>
              </Hidden> */}

              <Grid container className={classes.contentContainer}>
                <Grid item md={9} xs={12} className={classes.gridStyle} container spacing={isDesktop(theme) && 4}>
                  <Title align="center" textStyle={classes.titleHeader} className={classes.containerTitleHeader} variant="h5">{t('tools')}</Title>
                  <Grid item md={6} xs={12}>
                    <ToolsCard uri="/tools/bmi-calculator" src={bmiImg} title={t('myfitsociety:bmi_calculator')} description={t('myfitsociety:bmi_calculator_description')} />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ToolsCard uri="/tools/tdee-calculator" src={tdeeImg} title={t('myfitsociety:tdee_calculator')} description={t('myfitsociety:tdee_calculator_description')} />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ToolsCard uri="/tools/body-fat-calculator" src={bodyFatImg} title={t('myfitsociety:bodyfat_calculator')} description={t('myfitsociety:bodyfat_calculator_description')} />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <ToolsCard uri="/app-download" src={intervalImg} title={t('myfitsociety:interval_timer')} description={t('myfitsociety:interval_timer_description')} />
                  </Grid>
                </Grid>
                {renderGridAd()}
              </Grid>
            </Container>
          </section>
        </main>
        <section id="item-footer">
          <Footer invert />
        </section>
        <Notification />
      </div>
    </Fragment>
  );
}

Tools.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
};


export default withTranslation(['myfitsociety'])(Tools);
